import { render } from "./MainLayout.vue?vue&type=template&id=ee164574&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=ee164574&lang=css"
import "./MainLayout.vue?vue&type=style&index=1&id=ee164574&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee164574"]])

export default __exports__